'use es6';

import { createAction } from 'flux-actions';
import { UPDATE_THREAD_CURRENT_URL } from '../constants/actionTypes';
export const updateThreadCurrentUrl = createAction(UPDATE_THREAD_CURRENT_URL, ({
  currentUrl,
  threadId
}) => ({
  currentUrl,
  threadId
}));